import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routerObj = {
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/Home.vue"),
    },
    {
      path: "/infoPublic",
      name: "infoPublic",
      component: () => import("./views/infoPublic.vue"),
    },
    {
      path: "/schoolProfile",
      name: "schoolProfile",
      component: () => import("./views/schoolProfile.vue"),
    },
    {
      path: "/newsCenter",
      name: "newsCenter",
      component: () => import("./views/newsCenter.vue"),
    },
    {
      path: "/partyOnline",
      name: "partyOnline",
      component: () => import("./views/partyOnline.vue"),
    },
    {
      path: "/studentAndJob",
      name: "studentAndJob",
      component: () => import("./views/studentAndJob.vue"),
    },
    {
      path: "/imageCenter",
      name: "imageCenter",
      component: () => import("./views/imageCenter.vue"),
    },
    {
      path: "/talentRecruitment",
      name: "talentRecruitment",
      component: () => import("./views/talentRecruitment.vue"),
    },

    {
      path: "/mobleTip",
      name: "mobleTip",
      component: () => import("./views/mobleTip.vue"),
    },
    {
      path: "/honorCenter",
      name: "honorCenter",
      component: () => import("./views/honorCenter.vue"),
    },
    {
      path: "/linkCenter",
      name: "linkCenter",
      component: () => import("./views/linkCenter.vue"),
    },
    {
      path: "/subjectCenter",
      name: "subjectCenter",
      component: () => import("./views/subjectCenter.vue"),
    },

    {
      path: "/fillCustomForm",
      name: "fillCustomForm",
      component: () => import("./views/fillCustomForm.vue"),
    },
    {
      path: "/searchAllData",
      name: "searchAllData",
      component: () => import("./views/searchAllData.vue"),
    },
    {
      path: "*",
      name: "home",
      redirect: "/"
    },
  ],
}

let weishangrouter = new Router(routerObj);

// 判断是否需要登录权限 以及是否登录
weishangrouter.beforeEach((to, from, next) => {
  // 判断是否需要登录权限
  if (to.matched.some((res) => res.meta.requireAuth)) {
    // 判断是否登录
    if (sessionStorage.getItem("token")) {
      next();
    } else {
      // 没登录则跳转到登录界面
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
});

export default weishangrouter;
